import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Autocomplete,
  Box,
  Button,
  Divider,
  LinearProgress,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  saveRequest,
  cancelEmployeeExitRequest,
} from "../../../store/exit/actions";

import {
  getUnitPositions,
  getEntities,
  getEntitySectors,
} from "../../../store/structure/actions";
import { getRequestDocumentSignerDetails } from "../../../store/common/actions";

import moment from "moment";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { showError } from "../../toastify";
import axios from "axios";

const EmployeeExitRequestDialog = (props) => {
  const {
    loading,
    onWait,
    showEmployeeExitForm,
    setShowEmployeeExitForm,
    selectedEmployee,
    saveRequest,
    exitTypes,
    units,
    employeeExitRequest,
    cancelEmployeeExitRequest,
    getUnitPositions,
    positions,
    getEntities,
    entities,
    getEntitySectors,
    entitySectors,
    user,
  } = props;

  useEffect(() => {
    if (!entities.length) getEntities();
  }, []);
  //getEntities();
  const [loadingEntitySectors, setLoadingEntitySectors] = useState(false);
  const [exitType, setExitType] = useState(null);
  const [entity, setEntity] = useState(null);
  const [unit, setUnit] = useState(null);
  const [position, setPosition] = useState(null);

  const [entitySectorUnits, setEntitySectorUnits] = useState([]);
  const [employeeExitForm, setEmployeeExitForm] = useState({
    employeeId: selectedEmployee.employeeId,
    employeePositionId: selectedEmployee.employeePositionId,
    employeeGroupId: selectedEmployee.employeeGroupId,
    positionId: selectedEmployee.positionId,
    exitTypeId: "",
    effectiveDate: null,
    blacklistPeriod: 0,
    reason: "",
    bodyContent: "",
    docLetterNo: "",
    cc: [],
  });

  const [errors, setErrors] = useState({
    exitTypeHasError: false,
    reasonHasError: false,
    effectiveDateHasError: false,
    entityHasError: false,
    unitHasError: false,
    positionHasError: false,
    referenceLetterIdError: false,
    referenceLetterDateError: false,
    draftContentMaxCharHasError: false,
    docLetterNoError: false,
    effectiveDateError: false,
    ccHasError: false,
  });

  const formValidator = () => {
    const error = {
      exitTypeHasError: false,
      reasonHasError: false,
      effectiveDateHasError: false,
      entityHasError: false,
      unitHasError: false,
      positionHasError: false,
      hasError: false,
    };

    if (!exitType) {
      error.exitTypeHasError = true;
      error.hasError = true;
    }

    if (!employeeExitForm.reason) {
      error.reasonHasError = true;
      error.hasError = true;
    }

    if (!employeeExitForm.effectiveDate) {
      error.effectiveDateHasError = true;
      error.hasError = true;
    }

    if (!!exitType && exitType.id === 0 && !unit) {
      error.unitHasError = true;
      error.hasError = true;
    }

    if (!!exitType && exitType.id === 0 && !position) {
      error.positionHasError = true;
      error.hasError = true;
    }

    if (!!exitType && exitType.id === 6 && !entity) {
      error.entityHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  const getBlacklistPeriod = () =>
    +(exitType?.blacklistPeriod || 0) > 1
      ? (exitType?.blacklistPeriod || 0).toString() + " Years"
      : (exitType?.blacklistPeriod || 0).toString() + " Year";

  const onClose = () => {
    setShowEmployeeExitForm(false);
  };

  const onSave = () => {
    if (!exitType) {
      showError(`Please fill the exit type!`);
      return false;
    }

    if ([0, 6].includes(+exitType.id)) {
      if (!position) {
        showError(`No position selected.`);
        return false;
      }
      if (+position.numberOfVacantPosts === 0) {
        showError(
          `This position isn't available. there is (${position.numberOfVacantPosts}) number of vacant posts`
        );
        return false;
      }
    }

    if (!employeeExitForm?.effectiveDate) {
      showError(`Effective Date is required`);
      return false;
    }

    if (!employeeExitForm?.reason) {
      showError(`Reason is required`);
      return false;
    }

    saveRequest(
      {
        ...employeeExitForm,
        effectiveDate: moment(employeeExitForm.effectiveDate).format(
          "YYYY-MM-DD"
        ),
        entityId: entity?.entity?.id || null,
        positionId: position?.id || null,
        exitTypeId: exitType.id,
        cc:  [],
      },
      onClose
    );
  };

  const getNo = (idToSearch, data, key = "id") => {
    return data.findIndex((item) => item[key] === idToSearch) + 1;
  };

  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const getEntitySectorUnits = async (entitySectorId) => {
    try {
      setLoadingEntitySectors(true);
      const { data } = await axios.get(
        "/api/structure/entity-sector-units/" + entitySectorId
      );
      setEntitySectorUnits(data);
      setLoadingEntitySectors(false);
    } catch (error) {
      setLoadingEntitySectors(false);
      showError(error);
    }
  };

  // console.log(exitType);
  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showEmployeeExitForm}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="headerorg mb-0">
              <div className="header_cont">
                <span className="ml-0 text-dark">
                  EXIT REQUEST{" "}
                  {employeeExitRequest && employeeExitRequest?.exitType
                    ? " OF " + employeeExitRequest.exitType
                    : ""}
                  {exitType ? " OF " + exitType.name.toUpperCase() : ""} |{" "}
                </span>
                <span className="ml-0">
                  {selectedEmployee?.lastName} {selectedEmployee?.firstName}
                </span>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

        </DialogTitle>
        <DialogContent className="pb-2">
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="py-3">
              {/* {!isEmpty(employeeExitRequest) && ( */}
              <>
                  <>
                    <div className="row px-3 mt-4">
                      <div className="col-12 mb-2">
                        {" "}
                        {(loading || loadingEntitySectors) && (
                          <LinearProgress />
                        )}
                      </div>
                      <div className="col-12">
                        <Autocomplete
                          size="small"
                          id="exitType"
                          defaultValue={null}
                          value={exitType}
                          options={(() => {
                            const groupId = selectedEmployee?.employeeGroupId;

                            const tmpExitTypes = [
                              ...exitTypes.filter(
                                (type) => ![1003, 13].includes(+type.id)
                              ),
                            ];
                            const contractTermination = exitTypes.find(
                              (type) => type.id === 13
                            );
                            const endMandate = exitTypes.find(
                              (type) => type.id === 1003
                            );

                            if ([3, 6, 5, 7].includes(groupId)) {
                              tmpExitTypes.push(contractTermination);
                            }

                            if ([2, 4].includes(groupId)) {
                              tmpExitTypes.push(endMandate);
                            }

                            return tmpExitTypes;
                          })()}
                          disabled={loading}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          onChange={(event, exitType) => {
                            setExitType(exitType || null);
                            setPosition(null);
                            setUnit(null);
                            setEntity(null);

                            setEmployeeExitForm({
                              ...employeeExitForm,
                              exitTypeId: exitType?.id || "",
                            });
                            if (exitType.id === 6 && !entitySectors.length)
                              getEntitySectors();
                            setErrors({ ...errors, exitTypeHasError: false });
                            // if (!!exitType && exitType.id === 6) getEntities();
                          }}
                          getOptionLabel={(option) =>
                            getNo(option?.id, exitTypes) + ":" + option?.name
                          }
                          renderOption={(props, exitType) => (
                            <Box component="li" {...props}>
                              {getNo(exitType?.id, exitTypes)}: {exitType?.name}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              required={true}
                              disabled={loading}
                              {...params}
                              label="Select exit type"
                              placeholder="Select exit type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "ExitType", // disable autocomplete and autofill
                              }}
                            />
                          )}
                        />

                        {errors.exitTypeHasError && (
                          <small className="text-danger mb-1">
                            Please, select exit type
                          </small>
                        )}
                      </div>

                      {!!exitType && exitType.id === 6 && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="entity"
                            defaultValue={null}
                            value={entity}
                            options={entitySectors}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, entity) => {
                              setEntity(entity || null);
                              setPosition(null);
                              setUnit(null);
                              setEntitySectorUnits([]);
                              getEntitySectorUnits(entity.id);

                              setErrors({ ...errors, entityHasError: false });
                            }}
                            getOptionLabel={(option) =>
                              option?.entity.name +
                              (entity?.entity.acronym
                                ? "(" + entity?.entity.acronym + ")"
                                : "")
                            }
                            renderOption={(props, entity) => (
                              <Box component="li" {...props}>
                                {entity?.entity.name}
                                {entity?.entity.acronym && (
                                  <>({entity?.entity.acronym})</>
                                )}{" "}
                                <span className="ml-1 badge badge-primary">
                                  {" "}
                                  {entity?.sector.name}{" "}
                                </span>
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select the institution you are transferring to"
                                placeholder="Select the institution you are transferring to"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "entity", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.entityHasError && (
                            <small className="text-danger mb-1">
                              Please, select the institution
                            </small>
                          )}
                        </div>
                      )}

                      {!!exitType && exitType.id === 6 && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="unit"
                            defaultValue={null}
                            disabled={!entitySectorUnits.length}
                            value={unit}
                            options={entitySectorUnits}
                            isOptionEqualToValue={(option, value) =>
                              option.unitId === value.unitId
                            }
                            onChange={(event, unit) => {
                              setUnit(unit || null);
                              setPosition(null);

                              setErrors({ ...errors, unitHasError: false });

                              if (!!unit) getUnitPositions(unit.unitId);
                            }}
                            getOptionLabel={(option) => option?.unitName}
                            renderOption={(props, unit) => (
                              <Box component="li" {...props}>
                                {unit?.unitName}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select unit"
                                placeholder="Select unit"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "unit", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.unitHasError && (
                            <small className="text-danger mb-1">
                              Please, select unit
                            </small>
                          )}
                        </div>
                      )}

                      {!!exitType && exitType.id === 0 && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            size="small"
                            id="unit"
                            defaultValue={null}
                            value={unit}
                            options={units}
                            isOptionEqualToValue={(option, value) =>
                              option.unitId === value.unitId
                            }
                            onChange={(event, unit) => {
                              setUnit(unit || null);
                              setPosition(null);

                              setErrors({ ...errors, unitHasError: false });

                              if (!!unit) getUnitPositions(unit.unitId);
                            }}
                            getOptionLabel={(option) => option?.unitName}
                            renderOption={(props, unit) => (
                              <Box component="li" {...props}>
                                {unit?.unitName}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select unit"
                                placeholder="Select unit"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "unit", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.unitHasError && (
                            <small className="text-danger mb-1">
                              Please, select unit
                            </small>
                          )}
                        </div>
                      )}

                      {((!!exitType && exitType.id === 0) ||
                        (!!exitType && exitType.id === 6)) && (
                        <div className="col-12 mt-3">
                          <Autocomplete
                            disabled={!positions.length}
                            size="small"
                            id="position"
                            defaultValue={null}
                            value={position}
                            options={positions.filter(
                              ({ id }) => id != selectedEmployee.positionId
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, position) => {
                              setPosition(position || null);
                              // setEmployeeExitForm({
                              //   ...employeeExitForm,
                              //   positionId: position?.id || "",
                              // });

                              setErrors({ ...errors, positionHasError: false });
                            }}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, position) => (
                              <>
                                <Box component="li" {...props}>
                                  {position?.name}{" "}
                                  <span className="badge badge-secondary ml-1">
                                    {position?.employeeGroupName}
                                  </span>{" "}
                                  <span className="badge badge-primary ml-1">
                                    ({position?.numberOfVacantPosts})VacantPosts
                                  </span>
                                </Box>
                                <Divider />
                                <Divider />
                              </>
                            )}
                            renderInput={(params) => (
                              <TextField
                                required={true}
                                {...params}
                                label="Select position"
                                placeholder="Select position"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "position", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />

                          {errors.positionHasError && (
                            <small className="text-danger mb-1">
                              Please, select position
                            </small>
                          )}
                        </div>
                      )}

                      {(!exitType ||
                        (!!exitType &&
                          exitType.id !== 0 &&
                          exitType.id !== 6)) && (
                        <div className="col-12 mt-3 ">
                          <TextField
                            style={{ backgroundColor: "#eee" }}
                            fullWidth
                            size="small"
                            name="blacklistPeriod"
                            label="Blacklist Period"
                            value={getBlacklistPeriod()}
                            disabled
                            onChange={(e) => {
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                blacklistPeriod: e.target.value,
                              });
                            }}
                          />
                          {!!exitType?.blacklistPeriod ||
                            (0 > 0 && (
                              <span className="badge badge-primary">
                                To be Blacklisted in {getBlacklistPeriod()}
                              </span>
                            ))}
                        </div>
                      )}
                      <div className="col-12 mt-3 ">
                        <TextField
                          fullWidth
                          size="small"
                          name="reason"
                          required={true}
                          multiline
                          rows={3}
                          value={employeeExitForm.reason}
                          label={`Exit reason for ${exitType?.name || ""}`}
                          placeholder={`Exit reason for ${
                            exitType?.name || ""
                          }`}
                          inputProps={{ maxLength: 459 }}
                          onChange={(e) => {
                            setEmployeeExitForm({
                              ...employeeExitForm,
                              reason: e.target.value,
                            });

                            setErrors({ ...errors, reasonHasError: false });
                          }}
                        />
                        {errors.reasonHasError && (
                          <small className="text-danger mb-1">
                            Please, type exit reason.
                          </small>
                        )}
                      </div>

                      <div className="col-12 mt-3 ">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            label="Effective Date"
                            inputFormat="dd/MM/yyyy"
                            // disabled={
                            //   !exitType ||
                            //   (exitType && exitType.effectiveInDays > 0)
                            // }

                            minDate={
                              +exitType?.effectiveInDays > 0
                                ? moment().subtract(
                                    exitType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(
                                    user?.currentDate || new Date()
                                  ).subtract(30, "days")
                            }
                            maxDate={
                              +exitType?.effectiveInDays > 0
                                ? moment().add(
                                    exitType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(user?.currentDate || new Date()).add(
                                    60,
                                    "days"
                                  )
                            }
                            value={employeeExitForm.effectiveDate}
                            onChange={(date) => {
                              setEmployeeExitForm({
                                ...employeeExitForm,
                                effectiveDate: date,
                              });

                              setErrors({
                                ...errors,
                                effectiveDateHasError: false,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                onKeyDown={(e) => e.preventDefault()}
                                required={true}
                                fullWidth
                                size="small"
                                {...params}
                              />
                            )}
                          />

                          {errors.effectiveDateHasError && (
                            <small className="text-danger mt-1">
                              Effective date is required{" "}
                            </small>
                          )}
                        </LocalizationProvider>
                        {exitType && exitType.effectiveInDays > 0 && (
                          <span className="badge badge-primary">
                            This request will be effective after{" "}
                            {exitType.effectiveInDays} days if you don't adjust
                            the date
                          </span>
                        )}
                      </div>
                    </div>
                  </>
              
              
              </>
              {/* )} */}
            </div>
          </Box>
        </DialogContent>
        {/* {!isEmpty(employeeExitRequest) && ( */}
        <DialogActions className="d-flex justify-content-center pb-3">
     

            <Button
              color="success"
              variant="contained"
              disabled={loading || onWait || !exitType}
              onClick={onSave}
              size="md"
            >
              {onWait ? "Wait.." : <>Submit</>}
            </Button>
         
        </DialogActions>
        {/* )} */}
      </Dialog>

      {showConfirmationDialog && (
        <ConfirmationDialog
          confirmationDialog={showConfirmationDialog}
          message={`Are you sure you want to cancel the exit request for ${
            selectedEmployee?.lastName + " " + selectedEmployee?.firstName
          }?`}
          setConfirmationDialog={setShowConfirmationDialog}
          onYes={() => {
            cancelEmployeeExitRequest(
              employeeExitRequest.id,
              setShowConfirmationDialog
            );
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  exitTypes,
  employeeExitRequest,
  units,
  positions,
  entities,
  requestDocumentSignerDetail,
  entitySectors,
  user,
}) => {
  return {
    loading,
    onWait,
    exitTypes,
    employeeExitRequest,
    units,
    positions,
    entities,
    requestDocumentSignerDetail,
    entitySectors,
    user,
  };
};
export default connect(mapStateToProps, {
  saveRequest,
  cancelEmployeeExitRequest,
  getUnitPositions,
  getEntities,
  getEntitySectors,
  getRequestDocumentSignerDetails,
})(EmployeeExitRequestDialog);
